// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ★2026-10-12 「会話を評価」の進行ポップアップ／ピル（FeedbackProgressModal） */

.fbp-overlay {
    position: fixed;
    inset: 0;
    z-index: 1200;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    background: rgba(17, 20, 24, .55);
}

.fbp-modal {
    width: min(440px, 100%);
    padding: 22px 22px 18px;
    border-radius: 18px;
    background: #fff;
    color: #1a1d22;
    box-shadow: 0 20px 60px rgba(0, 0, 0, .35);
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Hiragino Kaku Gothic ProN", "Hiragino Sans", "Yu Gothic UI", Meiryo, sans-serif;
    font-size: 14px;
    line-height: 1.6;
}

.fbp-title {
    margin: 0 0 4px;
    font-size: 17px;
    font-weight: 700;
}

.fbp-sub {
    margin: 0 0 14px;
    color: #5b6470;
    font-size: 13px;
}

.fbp-steps {
    list-style: none;
    margin: 0 0 14px;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.fbp-steps li {
    display: flex;
    align-items: center;
    gap: 10px;
    color: #8a929e;
    font-size: 13px;
}

.fbp-steps li.active {
    color: #1a1d22;
    font-weight: 600;
}

.fbp-steps li.done {
    color: #5b6470;
}

.fbp-dot {
    flex: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    border: 2px solid #eaecef;
    border-radius: 50%;
    font-size: 11px;
}

.fbp-steps li.active .fbp-dot {
    border-color: #246fe5;
    border-top-color: transparent;
    animation: fbp-rot 1s linear infinite;
}

.fbp-steps li.done .fbp-dot {
    background: #189b55;
    border-color: #189b55;
    color: #fff;
}

.fbp-steps li.done .fbp-dot::after {
    content: "✓";
}

.fbp-track {
    height: 8px;
    margin: 6px 0;
    border-radius: 999px;
    background: #f0f2f4;
    overflow: hidden;
}

.fbp-fill {
    height: 100%;
    width: 0;
    border-radius: 999px;
    background: #246fe5;
    transition: width .4s ease;
}

.fbp-meta {
    display: flex;
    justify-content: space-between;
    margin-bottom: 14px;
    color: #8a929e;
    font-size: 12px;
}

.fbp-err {
    margin-bottom: 14px;
    padding: 10px 12px;
    border: 1px solid #ffd5d9;
    border-radius: 12px;
    background: #fff1f2;
    color: #8a1c27;
    font-size: 13px;
}

.fbp-row {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 8px;
}

.fbp-btn {
    padding: 9px 14px;
    border: 1px solid #eaecef;
    border-radius: 10px;
    background: #fff;
    color: #1a1d22;
    font: inherit;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
}

.fbp-btn.fbp-primary {
    border-color: #246fe5;
    background: #246fe5;
    color: #fff;
}

.fbp-btn:hover {
    filter: brightness(1.04);
}

.fbp-score {
    display: flex;
    align-items: baseline;
    gap: 8px;
    margin: 6px 0 10px;
}

.fbp-score b {
    font-size: 34px;
    line-height: 1;
    color: #246fe5;
}

.fbp-score span {
    color: #8a929e;
    font-size: 13px;
}

.fbp-stars {
    color: #f5a623 !important;
    font-size: 16px !important;
    letter-spacing: 2px;
}

/* 閉じて待っている間のピル（画面上部中央） */
.fbp-pill {
    position: fixed;
    top: 64px;
    left: 50%;
    z-index: 1100;
    display: flex;
    align-items: center;
    gap: 10px;
    max-width: 92vw;
    padding: 8px 14px;
    border-radius: 999px;
    background: rgba(17, 20, 24, .92);
    color: #fff;
    font-size: 13px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, .3);
    transform: translateX(-50%);
}

.fbp-pill button {
    padding: 3px 10px;
    border: 1px solid rgba(255, 255, 255, .4);
    border-radius: 999px;
    background: transparent;
    color: #fff;
    font: inherit;
    font-size: 12px;
    cursor: pointer;
}

.fbp-spin {
    width: 14px;
    height: 14px;
    border: 2px solid rgba(255, 255, 255, .3);
    border-top-color: #fff;
    border-radius: 50%;
    animation: fbp-rot 1s linear infinite;
}

@keyframes fbp-rot {
    to {
        transform: rotate(360deg);
    }
}
`, "",{"version":3,"sources":["webpack://./react/features/slide-view/components/web/feedback-progress.css"],"names":[],"mappings":"AAAA,2DAA2D;;AAE3D;IACI,eAAe;IACf,QAAQ;IACR,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,0CAA0C;IAC1C,4IAA4I;IAC5I,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,6BAA6B;IAC7B,qCAAqC;AACzC;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,QAAQ;IACR,oBAAoB;IACpB,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,yBAAyB;IACzB,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA,yBAAyB;AACzB;IACI,eAAe;IACf,SAAS;IACT,SAAS;IACT,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,iBAAiB;IACjB,oBAAoB;IACpB,iCAAiC;IACjC,WAAW;IACX,eAAe;IACf,wCAAwC;IACxC,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,yCAAyC;IACzC,oBAAoB;IACpB,uBAAuB;IACvB,WAAW;IACX,aAAa;IACb,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yCAAyC;IACzC,sBAAsB;IACtB,kBAAkB;IAClB,qCAAqC;AACzC;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ","sourcesContent":["/* ★2026-10-12 「会話を評価」の進行ポップアップ／ピル（FeedbackProgressModal） */\n\n.fbp-overlay {\n    position: fixed;\n    inset: 0;\n    z-index: 1200;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 16px;\n    background: rgba(17, 20, 24, .55);\n}\n\n.fbp-modal {\n    width: min(440px, 100%);\n    padding: 22px 22px 18px;\n    border-radius: 18px;\n    background: #fff;\n    color: #1a1d22;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, .35);\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Hiragino Kaku Gothic ProN\", \"Hiragino Sans\", \"Yu Gothic UI\", Meiryo, sans-serif;\n    font-size: 14px;\n    line-height: 1.6;\n}\n\n.fbp-title {\n    margin: 0 0 4px;\n    font-size: 17px;\n    font-weight: 700;\n}\n\n.fbp-sub {\n    margin: 0 0 14px;\n    color: #5b6470;\n    font-size: 13px;\n}\n\n.fbp-steps {\n    list-style: none;\n    margin: 0 0 14px;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.fbp-steps li {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    color: #8a929e;\n    font-size: 13px;\n}\n\n.fbp-steps li.active {\n    color: #1a1d22;\n    font-weight: 600;\n}\n\n.fbp-steps li.done {\n    color: #5b6470;\n}\n\n.fbp-dot {\n    flex: none;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 20px;\n    height: 20px;\n    border: 2px solid #eaecef;\n    border-radius: 50%;\n    font-size: 11px;\n}\n\n.fbp-steps li.active .fbp-dot {\n    border-color: #246fe5;\n    border-top-color: transparent;\n    animation: fbp-rot 1s linear infinite;\n}\n\n.fbp-steps li.done .fbp-dot {\n    background: #189b55;\n    border-color: #189b55;\n    color: #fff;\n}\n\n.fbp-steps li.done .fbp-dot::after {\n    content: \"✓\";\n}\n\n.fbp-track {\n    height: 8px;\n    margin: 6px 0;\n    border-radius: 999px;\n    background: #f0f2f4;\n    overflow: hidden;\n}\n\n.fbp-fill {\n    height: 100%;\n    width: 0;\n    border-radius: 999px;\n    background: #246fe5;\n    transition: width .4s ease;\n}\n\n.fbp-meta {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 14px;\n    color: #8a929e;\n    font-size: 12px;\n}\n\n.fbp-err {\n    margin-bottom: 14px;\n    padding: 10px 12px;\n    border: 1px solid #ffd5d9;\n    border-radius: 12px;\n    background: #fff1f2;\n    color: #8a1c27;\n    font-size: 13px;\n}\n\n.fbp-row {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-end;\n    gap: 8px;\n}\n\n.fbp-btn {\n    padding: 9px 14px;\n    border: 1px solid #eaecef;\n    border-radius: 10px;\n    background: #fff;\n    color: #1a1d22;\n    font: inherit;\n    font-size: 13px;\n    font-weight: 600;\n    cursor: pointer;\n}\n\n.fbp-btn.fbp-primary {\n    border-color: #246fe5;\n    background: #246fe5;\n    color: #fff;\n}\n\n.fbp-btn:hover {\n    filter: brightness(1.04);\n}\n\n.fbp-score {\n    display: flex;\n    align-items: baseline;\n    gap: 8px;\n    margin: 6px 0 10px;\n}\n\n.fbp-score b {\n    font-size: 34px;\n    line-height: 1;\n    color: #246fe5;\n}\n\n.fbp-score span {\n    color: #8a929e;\n    font-size: 13px;\n}\n\n.fbp-stars {\n    color: #f5a623 !important;\n    font-size: 16px !important;\n    letter-spacing: 2px;\n}\n\n/* 閉じて待っている間のピル（画面上部中央） */\n.fbp-pill {\n    position: fixed;\n    top: 64px;\n    left: 50%;\n    z-index: 1100;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    max-width: 92vw;\n    padding: 8px 14px;\n    border-radius: 999px;\n    background: rgba(17, 20, 24, .92);\n    color: #fff;\n    font-size: 13px;\n    box-shadow: 0 8px 24px rgba(0, 0, 0, .3);\n    transform: translateX(-50%);\n}\n\n.fbp-pill button {\n    padding: 3px 10px;\n    border: 1px solid rgba(255, 255, 255, .4);\n    border-radius: 999px;\n    background: transparent;\n    color: #fff;\n    font: inherit;\n    font-size: 12px;\n    cursor: pointer;\n}\n\n.fbp-spin {\n    width: 14px;\n    height: 14px;\n    border: 2px solid rgba(255, 255, 255, .3);\n    border-top-color: #fff;\n    border-radius: 50%;\n    animation: fbp-rot 1s linear infinite;\n}\n\n@keyframes fbp-rot {\n    to {\n        transform: rotate(360deg);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
